module.exports = __webpack_public_path__ + "static/media/han-taste-ad2.5f88eeec.png";